export default __webpack_public_path__ + "static/media/hat-monogram.ddfbc177.svg";